import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { SettingsValueService } from 'app/shared/services/settings-value-service';

@UntilDestroy()
@Component({
  selector: 'kh-settings-value',
  styleUrls: ['./settings-value.component.less'],
  templateUrl: './settings-value.component.html',
  standalone: false
})

export class SettingsValueComponent implements OnInit {
  protected readonly settingsValueService = inject(SettingsValueService);
  protected readonly changeDetector = inject(ChangeDetectorRef);

  @Input() public label = '';
  @Input() public value = '';
  @Input() public valueList: string[] = [];
  @Input() public editButtonLabel = '';
  @Input() public isEditable = true;
  @Input() public editColor = '#647797';
  @Input() public invertSaveButtonOrder = false;
  @Input() public instanceName = '';
  @Input() public hideSaveButton = false;
  @Input() public testId = '';

  @Output() public clickSave = new EventEmitter<void>();
  @Output() public resetForm = new EventEmitter<void>();
  @Output() public startEditing = new EventEmitter<void>();

  public isEditing = false;
  public disableSaveButton = false;
  public pensilIcon = faPencilAlt;
  public activeInstance$: Observable<string | null> | undefined;

  public ngOnInit(): void {
    this.settingsValueService.instance$
      .pipe(
        tap((instance) => {
          if (this.instanceName !== '' && this.instanceName !== instance) {
            this.isEditing = false;
            this.changeDetector.detectChanges();
          }
        }
        ),
        untilDestroyed(this)
      )
      .subscribe();

    this.settingsValueService.disableSaveButton$
      .pipe(
        tap(
          (value) => {
            this.disableSaveButton = value;
          }
        ),
        untilDestroyed(this)
      )
      .subscribe();

    this.settingsValueService.toggleEditing.subscribe((instance) => {
      if (this.instanceName === instance) {
        this.toggleEditing();
      }
    });
  }

  public toggleEditing(): void {
    this.isEditing = !this.isEditing;

    if (this.isEditing) {
      this.startEditing.emit();
    }
  }

  public saveClicked(): void {
    this.clickSave.emit();
  }

  public cancelClicked(): void {
    this.resetForm.emit();
    this.toggleEditing();
  }
}
